export default {
  layout ({ route }) {
    return typeof route.query.plain !== 'undefined'
      ? 'plain'
      : 'landing'
  },

  computed: {
    iframed () {
      return typeof this.$route.query.plain !== 'undefined'
    }
  }
}
